import { render, staticRenderFns } from "./PlbscfReadonlyValue.vue?vue&type=template&id=52c11f56&"
import script from "./PlbscfReadonlyValue.ts?vue&type=script&lang=ts&"
export * from "./PlbscfReadonlyValue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports